import app from 'flarum/forum/app';

export const calculatePercentage = (currentPoints: unknown): number => {
  const maxPoints: number = Number(app.forum.attribute('maxPoints')) || 1000;
  const validMaxPoints: number = maxPoints > 0 ? maxPoints : 100;
  const percentage: number = (Number(currentPoints) / validMaxPoints) * 100;
  return Math.min(parseFloat(percentage.toFixed(3)), 100);
};
